export function isWechat() {
    const ua = navigator.userAgent.toLowerCase();
    return ua.match(/MicroMessenger/i) == "micromessenger";
  }
  
  export function showBrowserPrompt() {
    if (isWechat()) {
      localStorage.setItem('wechatBrowserPrompt', true)
      return true
    } else {
      localStorage.setItem('wechatBrowserPrompt', false)
     console.log("浏览器");
    }
  }
  // 判断是否在微信浏览器中打开